export const MESSAGING_METHOD_EMAIL = 'email';
export const MESSAGING_METHOD_MSTEAMS = 'msteams';
export const MESSAGING_METHOD_SLACK = 'slack';
export const MESSAGING_METHODS = [
  MESSAGING_METHOD_EMAIL,
  MESSAGING_METHOD_MSTEAMS,
  MESSAGING_METHOD_SLACK,
];
export const MESSAGING_METHOD_FEEDBACK_FUNCTION = 'feedback';
export const MESSAGING_METHOD_INTRODUCTION_FUNCTION = 'introduction';
export const MESSAGING_METHOD_REMINDER_FUNCTION = 'reminder';
export const MESSAGING_METHOD_INTRODUCTION_FUNCTION_OPTIONS = [
  MESSAGING_METHOD_FEEDBACK_FUNCTION,
  MESSAGING_METHOD_INTRODUCTION_FUNCTION,
  MESSAGING_METHOD_REMINDER_FUNCTION,
];
export const MESSAGING_METHOD_OPPORTUNITY_FEEDBACK_FUNCTION =
  'opportunityFeedback';
export const MESSAGING_METHOD_OPPORTUNITY_FEEDBACK_HOST_FUNCTION =
  'opportunityFeedbackHost';
export const MESSAGING_METHOD_OPPORTUNITY_CREATED_HOST_FUNCTION =
  'opportunityCreatedHost';
export const MESSAGING_METHOD_OPPORTUNITY_CREATED_EDITOR_FUNCTION =
  'opportunityCreatedEditor';
export const MESSAGING_METHOD_OPPORTUNITY_CREATED_FUNCTION =
  'opportunityCreated';
export const MESSAGING_METHOD_OPPORTUNITY_UPDATED_FUNCTION =
  'opportunityUpdated';
export const MESSAGING_METHOD_PATHWAY_INVITATION = 'pathwayInvitation';
export const MESSAGING_METHOD_PATHWAY_ENROLLMENT = 'pathwayEnrollment';
export const MESSAGING_METHOD_PROGRAM_FEEDBACK = 'programFeedback';
export const MESSAGING_METHOD_PROGRAM_INVITATION = 'programInvitation';
export const MESSAGING_METHOD_PROGRAM_MATCHMAKING = 'programMatchmaking';
export const MESSAGING_METHOD_PROGRAM_SUMMARY = 'programSummary';
export const MESSAGING_METHOD_PROGRAM_TOUCHPOINT = 'programTouchpoint';
export const MESSAGING_METHOD_PROGRAM_TOUCHPOINT_RECIPROCATION =
  'programTouchpointReciprocation';
